import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Customer } from 'src/app/classes/customer';
import { AuthService } from 'src/app/services/auth.service';
import { ContactService } from 'src/app/services/contact.service';
import { LocationService } from 'src/app/services/location.service';
import { SettingsService } from 'src/app/services/settings.service';
import { environment } from 'src/environments/environment';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { CustomerContact } from 'src/app/classes/customer-contact';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PayBalanceComponent } from './pay-balance/pay-balance.component';
import { CustomerContactCard } from 'src/app/classes/customer-contact-card';
import { EditCardComponent } from './edit-card/edit-card.component';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';
import { PaymentService } from 'src/app/services/payment.service';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { Organization } from 'src/app/classes/organization';
import { DiscountsComponent } from './discounts/discounts.component';
import { ReferralsComponent } from './referrals/referrals.component';
import { LocationComponent } from './location/location.component';
import { PersonalComponent } from './personal/personal.component';
import { AuthImgPipe } from 'src/app/pipes/auth-img.pipe';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  providers: [AuthImgPipe]
})

export class SettingsComponent  implements OnInit {
  @ViewChild('pictureTag') pictureTag!: ElementRef;
  environment = environment
  contact = new CustomerContact()
  customers: Customer[] = []
  organization = new Organization()
  fa = fa

  form = new FormGroup({
    email: new FormControl('', [Validators.email, Validators.required]),
    first_name: new FormControl('', [Validators.required]),
    last_name: new FormControl('', [Validators.required]),
    mobile_phone: new FormControl('', [Validators.required]),
  })

  constructor(
    private settingsService: SettingsService,
    private modalService: NgbModal,
    public router: Router,
    private paymentService: PaymentService,
    private authImgPipe: AuthImgPipe,
    private titleService: Title
  ) { }

  ngOnInit() {
    this.titleService.setTitle($localize `Settings`)

    this.settingsService.organization().subscribe(organization => {
      this.organization = organization
    })
    
    this.get();
  }

  get() {
    this.settingsService.get().subscribe(settings => {
      this.contact = settings

      this.form.patchValue(settings)
      
      this.customers = settings.customers
    })
  }

  editLocation(customer: Customer | null) {
    const modal = this.modalService.open(LocationComponent, { centered: true })
    
    modal.componentInstance.customer = customer ? customer : new Customer()
    
    modal.result.then(() => {
      this.get()
    })
  }

  personalInfo() {
    const modal = this.modalService.open(PersonalComponent, { centered: true })

    modal.componentInstance.contactId = this.contact.id

    modal.result.then(() => {
      this.get()
    })
  }

  addCard() {
    const platform = Capacitor.getPlatform()

    this.paymentService.payment(this.organization.payment_api, { 
      card: 'new_card', 
      amount: 0, 
      title: $localize`Temporary hold`, 
      locale: $localize.locale, 
      platform: platform,
      saveCard: true,
      temporaryHold: true
    }).subscribe(async payment => {
      if (platform != 'web') {
        await Browser.open({ url: payment.redirect_url })

        Browser.addListener('browserFinished', () => {
          this.get()
          Browser.removeAllListeners()
        })

        this.paymentService.wait(`${payment.id}`).subscribe(async (payment) => {
          Browser.removeAllListeners()
          await Browser.close()
          this.get()
        })
      }
      else {
        location.href = payment.redirect_url
      }      
    })
  }

  editCard(card: CustomerContactCard) {
    const modal = this.modalService.open(EditCardComponent, { centered: true })

    modal.componentInstance.contact = this.contact
    modal.componentInstance.card = card

    modal.result.then(() => { 
      this.settingsService.get().subscribe(settings => {
        this.contact = settings
      })
    })
  }

  paymentHistory() {
    const modal = this.modalService.open(PaymentHistoryComponent, { centered: true, size: 'xl', scrollable: true })

    modal.componentInstance.contact = this.contact
  }

  discounts() {
    const modal = this.modalService.open(DiscountsComponent, { centered: true, size: 'lg' })
  }

  referrals() {
    const modal = this.modalService.open(ReferralsComponent, { centered: true, size: 'lg' })
  }

  payBalance() {
    const modal = this.modalService.open(PayBalanceComponent, { centered: true })

    modal.componentInstance.contact = this.contact

    modal.result.then(() => {
      this.settingsService.get().subscribe(settings => {
        this.contact = settings
      })    
    })
  }

  removeAccount(){
    if(confirm($localize`Are you sure?`)) {
      this.settingsService.removeAccount().subscribe(_data => {
        alert($localize `Account removed`)
        this.router.navigate(['/logout'])
      })
    }
  }

  save() {
    this.settingsService.save(this.form.value).subscribe(_data => {
      alert($localize `Profile saved`)
      this.router.navigate(['/'])
    })
  }

  pictureUpload(event: any) {
    const file = event.target.files[0]
    if (file) {
      const formData = new FormData()
      formData.append('file', file)
      
      this.settingsService.uploadPicture(formData).subscribe(() => {
        this.authImgPipe.transform(`/api/customer/contacts/${this.contact.id}/picture`).subscribe(image => {
          this.pictureTag.nativeElement.src = image.changingThisBreaksApplicationSecurity
        })
      })
    }
  }
}